module.exports = __webpack_public_path__ + "img/screenshot-20230118-121548.871bc9d4.png";